module.exports = __webpack_public_path__ + "static/media/xiuguluanshan3.340ecf17.webp";